import { render, staticRenderFns } from "./divide-earnings.vue?vue&type=template&id=655e7396&scoped=true"
import script from "./divide-earnings.vue?vue&type=script&lang=js"
export * from "./divide-earnings.vue?vue&type=script&lang=js"
import style0 from "./divide-earnings.vue?vue&type=style&index=0&id=655e7396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e7396",
  null
  
)

export default component.exports